import { Component, OnInit, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { LayoutComponent } from '../../core/layout/layout.component';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, Router } from '@angular/router';
import { ManualJournalService } from '../../features/manual-journals/services/manual-journal.service';
import { JournalStatusEnum } from '../../../assets/journalStatus';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
// import { PermissionDirective } from '../../shared/directives/permissions.directive';
// import { Permission } from '../../shared/services/permissions';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { ToastrService } from 'ngx-toastr';
import { ModuleIds } from '../../shared/permission-constants/permission-const';
import { PermissionService } from '../../shared/services/permission.service';

@Component({
  selector: 'app-manual-journal-details',
  standalone: true,
  imports: [
    CommonModule,
    LayoutComponent,
    MatInputModule,
    MatTabsModule,
    // PermissionDirective
  ],
  templateUrl: './manual-journal-details.component.html',
  styleUrl: './manual-journal-details.component.scss',
})
export class ManualJournalDetailsComponent implements OnInit {
  selectedTabIndex = 0; // Default to the first tab
  selectedjournalId: any;
  journalId!: any;
  journalData: any = {};
  allJournals: any[] = [];
  journalEntries: any[] = [];
  journalDate: string;
  contactName: string;
  debitTotal: number = 0;
  creditTotal: number = 0;
  isAttachFile = false;
  private searchSubject = new Subject<string>();
  public loading: boolean = true;
  public journalStatuses = Object.values(JournalStatusEnum);
  public selectedStatuses: JournalStatusEnum[] = [];
  public journalStatusValue: string = 'All Journals';
  // Permission = Permission;
  canListManualJournal$ = this.permissionService.hasPermission(
    ModuleIds.ManualJournal,
    'List'
  );
  canCreateManualJournal$ = this.permissionService.hasPermission(
    ModuleIds.ManualJournal,
    'Create'
  );
  canEditManualJournal$ = this.permissionService.hasPermission(
    ModuleIds.ManualJournal,
    'Edit'
  );
  canPublishManualJournal$ = this.permissionService.hasPermission(
    ModuleIds.ManualJournal,
    'Publish'
  );
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private journalService: ManualJournalService,
    private date: DatePipe,
    private toastr: ToastrService,
    private permissionService: PermissionService
  ) {}

  ngOnInit(): void {
    this.fetchAllJournals();
    // this.fetchJournalById();
    this.route.paramMap.subscribe((params) => {
      this.journalId = Number(params.get('id'));
      if (this.journalId) {
        this.fetchJournalById(this.journalId);
      }
    });
    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.fetchAllJournals(searchTerm);
      });
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.searchSubject.next(searchTerm);
  }

  // New getter to compute the journal title based on the filter
  get journalTitle(): string {
    return this.selectedStatuses.length
      ? this.selectedStatuses[0] + ' Journals'
      : 'All Journals';
  }

  applyFilter(event: Event) {
    event.preventDefault();

    // Update journalStatusValue based on selected status
    this.journalStatusValue = this.selectedStatuses.length
      ? this.selectedStatuses[0]
      : 'All Journals';

    this.fetchAllJournals();
    this.toggleDropdown();
  }

  clearFilter() {
    this.selectedStatuses = [];
    this.journalStatusValue = 'All Journals'; // Reset displayed status
    this.fetchAllJournals();
  }

  onStatusChange(status: JournalStatusEnum, event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const isChecked = inputElement.checked;

    if (isChecked) {
      this.selectedStatuses.push(status);
    } else {
      this.selectedStatuses = this.selectedStatuses.filter((s) => s !== status);
    }
  }

  // Method to navigate to the Edit page
  navigateToEditPage(): void {
    const selectedJournal = this.allJournals[this.selectedTabIndex];
    const journalId = selectedJournal.id;

    // Navigate to the edit page and pass the journal ID
    this.router.navigate([`manual-journals/edit/${journalId}`]);
  }

  publishJournal() {
    const selectedJournal = this.allJournals[this.selectedTabIndex];
    const journalId = selectedJournal.id;
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        title: 'Confirm Publishing',
        message: `Are you sure you want to publish this journal`,
        confirmText: 'Publish',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.journalService.publishJournal(journalId).subscribe({
          next: () => {
            this.toastr.success('Journal published successfully.');
            this.fetchAllJournals();
            this.fetchJournalById(journalId);
          },
          error: (error) => {
            this.toastr.error(error.message || 'Failed to publish journal.');
          },
        });
      }
    });
  }

  fetchAllJournals(search: string = '', filter: any = {}): void {
    this.loading = true;

    const filterCriteria = {
      ...filter,
      status: this.selectedStatuses.length
        ? this.selectedStatuses[0]
        : undefined,
    };

    this.journalService.fetchManualJournals(search).subscribe({
      next: (journals) => {
        this.allJournals = journals;
        // if (this.allJournals.length > 0) {
        //   this.selectTab(0);
        // }
        if (this.journalId) {
          const targetId = +this.journalId;
          this.selectedTabIndex = this.allJournals.findIndex((c: any) => {
            return c.id === targetId;
          });
          if (this.selectedTabIndex === -1) {
            this.selectedTabIndex = 0;
          }
        } else {
          this.selectedTabIndex = 0;
        }
        //this.journalData = this.allJournals[this.selectedTabIndex] || {};
        // this.selectTab(this.selectedTabIndex);
      },
      error: (err) => {
        console.error('Error fetching all journals:', err);
      },
    });
  }

  findSum(journalEnteries: any[]) {
    return journalEnteries.reduce((total, entry) => {
      return total + entry?.debit;
    }, 0);
  }

  fetchJournalById(journalid: number) {
    this.journalService.getJournalById(journalid).subscribe({
      next: (journal) => {
        this.journalData = journal;
        this.journalEntries = this.journalData?.journalEntries || [];
        console.log('this.journalEntries', this.journalEntries);
      },
      error: (error) => {
        console.error('Error fetching journal:', error);
      },
    });
  }

  selectTab(index: number): void {
    this.selectedTabIndex = index;
    this.selectedjournalId = this.allJournals[index].id;
    this.fetchJournalById(this.selectedjournalId);
    if (this.journalData) {
      this.router.navigate([
        `manual-journals/detail/${this.selectedjournalId}`,
      ]);
    }
    this.calculateTotals();
  }

  calculateTotals(): void {
    this.debitTotal = this.journalEntries.reduce(
      (total, entry) => total + (entry.debit || 0),
      0
    );
    this.creditTotal = this.journalEntries.reduce(
      (total, entry) => total + (entry.credit || 0),
      0
    );
  }

  readonly dialog = inject(MatDialog);

  getJournalStatusImage(status: string | undefined): string {
    if (status === 'Published') {
      return 'assets/images/published.svg';
    } else {
      return 'assets/images/img-draft.svg';
    }
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  openDialog() {
    const dialogRef = this.dialog.open(UploadJournalDialog);
  }

  isDropdownOpen = false;

  toggleDropdown(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  toggleAttachFile(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isAttachFile = !this.isAttachFile;
  }

  viewAttachments(url: any) {
    const token = localStorage.getItem('AUTH_TOKEN');
    fetch(url, {
      method: 'GET',
      headers: {
        authorization: token ? `Bearer ${token}` : '',
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      })
      .catch((error) => console.error('Error:', error));
  }

  onRemoveDocument(id: any) {
    if (id) {
      const dialogRef = this.dialog.open(ConfirmDialog);
      dialogRef.afterClosed().subscribe((result) => {
        if (result === true) {
          this.journalService.removeJournal(Number(id)).subscribe({
            next: (data) => {
              if (data) {
                this.toastr.success(
                  'Attachment removed successfully',
                  'Success'
                );

                this.fetchAllJournals();
              }
            },
            error: (error) => this.toastr.error(error, 'Error'),
          });
        }
      });
    }
  }
}

@Component({
  selector: 'upload-journal-details-dialog',
  templateUrl: 'upload-journal-details-dialog.html',
  styleUrls: ['./manual-journal-details.component.scss'],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
})
export class UploadJournalDialog {
  file: any = null;

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      console.log('Selected file:', file);
      this.file = file;
    }
  }
}
